import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "index";

import { GridSize } from "@mui/material/Grid";
import { Grid } from "@mui/material";

import { ApplicationState } from "@store/index";
import { getProvider } from "fileParsing/definitions";
import { switchActive } from "@store/data/actions";
import useTranslations from "containers/hooks/useLanguageHook";

import Timeline from "../Visuals/Timeline";
import { useContentSize } from "containers/hooks/useWindowSize";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { calculateGridItemSize } from "@utils/format";
import useTheme from "@mui/material/styles/useTheme";
const TimelineImage = new URL("../../../public/timeline.png", import.meta.url).href;

function TimelinePage() {
  const contentSize = useContentSize();
  const dispatch = useAppDispatch();
  const { t } = useTranslations();
  const theme = useTheme();
  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Timeline));
  }, []);

  const activeExports = providerItems.filter((d) => d.active);

  return (
    <VisPageWrapper
      title={t.Vis.TheTimeline}
      help={{
        title: t.LandingPage.TimelineTitle,
        description: t.LandingPage.TimelineText,
        image: TimelineImage,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1}>
          {activeExports.map((d, i, list) => (
            <Grid item xs={calculateGridItemSize(list.length) as GridSize} key={d.id}>
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={d.providerId === "wrangled" ? t.DataPage.UnknownProvider : getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              <Timeline
                exportId={d.id}
                size={{
                  height: `calc(${contentSize.height / 2 - 28}px)`,
                  width: "100%",
                }}
                yLabelSteps={2 * activeExports.length}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Timeline
          size={{
            height: contentSize.height - theme.sidebar.footerHeight,
            width: contentSize.width,
          }}
          yLabelSteps={2}
        />
      )}
    </VisPageWrapper>
  );
}

export { TimelinePage };
